// src/i18n/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import translationEN from './locales/en/translation.json';
import translationSL from './locales/sl/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: translationEN,
      },
      sl: {
        translation: translationSL,
      },
    },
    fallbackLng: 'sl',
    debug: true, // Začasno vključim debug za lažje odkrivanje napak
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
